import React, { ReactElement } from "react";
import { Button } from "@material-ui/core";
import { AxiosResponse } from "axios";
import { InvoiceFileResponse } from "../../models/Invoice";
import { CSVFileViewer } from "./CSVFileViewer";

export interface InvoiceFileSetFileSectionProps {
	//The callback method for handling reprocessing of the invoice.
	handleReprocessing: (invoiceHistoryId: string) => void;
	//The callback method for handling the submission of the file set to accounting.
	handleFileSubmission: (invoiceHistoryId: string, accountingFileName: string) => void;
	//The callback method for retrieving the invoice or accounting file to be displayed in the dialog.
	retrieveFile: (invoiceHistoryId: string, fileName: string) => Promise<AxiosResponse<InvoiceFileResponse>>;
	//The callback method to be passed to the various sections of the card to set the dialog contents for the page.
	setDialogContent: (title: string, content: ReactElement | undefined, titleBarContent?: ReactElement) => void;
	//The callback method for generating a download of one of the files.
	generateFileDownloadLink: (invoiceHistoryId: string, fileName: string) => string;
	//The name of the invoice file.
	invoiceFileName: string;
	//The name of the accounting file.
	accountingFileName: string;
	//The invoice history id to be used to retrieve the record in the DB.
	invoiceHistoryId: string;
}

/**
 * This component displays buttons for reprocessing the invoice file, submitting the accounting file,
 *  viewing the accounting file, and viewing the invoice file.
 * @param props
 */
export const InvoiceFileSetFileSection = (props: InvoiceFileSetFileSectionProps) => {
	const handleRetrievingFile = async (fileName: string) => {
		const response = await props.retrieveFile(props.invoiceHistoryId, fileName);
		props.setDialogContent(
			response.data.fileName,
			<CSVFileViewer file={response.data.file}></CSVFileViewer>,
			<Button
				size="small"
				variant="contained"
				color={"primary"}
				style={{ margin: 10, color: "#fff" }}
				href={props.generateFileDownloadLink(props.invoiceHistoryId, fileName)}
			>
				Download File
			</Button>,
		);
	};

	return (
		<div>
			<div
				style={{
					marginTop: 10,
					marginRight: "auto",
					marginLeft: 5,
					maxWidth: 610,
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<Button
					size="small"
					variant="contained"
					color={"primary"}
					style={{ margin: 5 }}
					onClick={() => handleRetrievingFile(props.invoiceFileName)}
					data-testid="view-invoice-file-button"
				>
					{"View Invoice File"}
				</Button>
				{props.accountingFileName && props.accountingFileName && (
					<Button
						size="small"
						variant="contained"
						color={"primary"}
						style={{ margin: 5 }}
						onClick={() => handleRetrievingFile(props.accountingFileName)}
						data-testid="view-accounting-file-button"
					>
						{"View Accounting File"}
					</Button>
				)}
				<Button
					size="small"
					variant="contained"
					color={"primary"}
					style={{ margin: 5 }}
					onClick={() => props.handleReprocessing(props.invoiceHistoryId)}
					data-testid="reprocess-file-button"
				>
					{"Reprocess File"}
				</Button>
				{props.accountingFileName && props.accountingFileName && (
					<Button
						size="small"
						variant="contained"
						color={"primary"}
						style={{ margin: 5 }}
						onClick={() => {
							props.handleFileSubmission(props.invoiceHistoryId, props.accountingFileName);
						}}
						data-testid="submit-file-button"
					>
						{"Submit File"}
					</Button>
				)}
			</div>
		</div>
	);
};
